import React, { useState } from 'react'
import { Modal, Icon } from 'antd'
import LazyLoad from 'react-lazyload'

const FbaImagePreview = ({ url, downloadUrl, size = 80, alt = 'preview' }) => {
    const [visible, setVisible] = useState(false)

    if (!url) return <span className='text-muted'>—</span>

    return (
        <div className='FbaImagePreview position-relative' style={{ width: size, height: size }}>
            <img src={url} className='position-absolute' alt={alt} />

            <div className='FbaImageActions d-flex justify-content-center align-items-center position-absolute'>
                <span className='FbaImageIcon cursor-pointer mr-1' onClick={() => setVisible(true)}>
                    <Icon type='eye' />
                </span>
                {downloadUrl && (
                    <a href={downloadUrl} download className='FbaImageIcon'>
                        <Icon type='download' />
                    </a>
                )}
            </div>

            <Modal
                visible={visible}
                closable={false}
                centered
                footer={null}
                width={1200}
                onCancel={() => setVisible(false)}
                className='PrintedFileModal mw-1200'
            >
                <div className='Previewer'>
                    <LazyLoad>
                        <img src={url} alt={alt} className='d-block m-auto' />
                    </LazyLoad>
                </div>
            </Modal>
        </div>
    )
}

export default FbaImagePreview
